import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ff3cea9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4ff3cea9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3cea9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff3cea9')) {
      api.createRecord('4ff3cea9', component.options)
    } else {
      api.reload('4ff3cea9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ff3cea9&scoped=true&", function () {
      api.rerender('4ff3cea9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/Turntable/index.vue"
export default component.exports